export enum PracticeAuthorizations {
  RicercaPratiche = 'PRATICHE.RESIDENZA.QUERY',
  AperturaResidenza = 'PRATICHE.APERTURA.RESID',
  AperturaImmigrazione = 'PRATICHE.APERTURA.IMMIGR',
  AperturaAnagrafeTemporanea = 'PRATICHE.APERTURA.TEMRES',
  AperturaIrreperibilita = 'PRATICHE.APERTURA.IRREP',
  AperturaEmigrazione = 'PRATICHE.APERTURA.EMIGR',
  StampaIrreperibilita = 'PRATICHE.STAMPA.IRRPREF',
  RicercaRegistro = 'PRATICHE.REGISTRO.QUERY',
  NuovoRegistro = 'PRATICHE.REGISTRO.ADD',
  ModificaRegistro = 'PRATICHE.REGISTRO.UPDATE',
  EliminaRegistro = 'PRATICHE.REGISTRO.DELETE',
  RicercaTipoPratica = 'PRATICHE.TIPOPRATICA.QUERY',
  NuovoTipoPratica = 'PRATICHE.TIPOPRATICA.ADD',
  ModificaTipoPratica = 'PRATICHE.TIPOPRATICA.UPDATE',
  EliminaTipoPratica = 'PRATICHE.TIPOPRATICA.DELETE',
  RicercaTipoOperazione = 'PRATICHE.TIPOOPERAZIONE.QUERY',
  NuovoTipoOperazione = 'PRATICHE.TIPOOPERAZIONE.ADD',
  ModificaTipoOperazione = 'PRATICHE.TIPOOPERAZIONE.UPDATE',
  EliminaTipoOperazione = 'PRATICHE.TIPOOPERAZIONE.DELETE',
  RicercaResponsabile = 'PRATICHE.RESPONSABILE.QUERY',
  NuovoResponsabile = 'PRATICHE.RESPONSABILE.ADD',
  ModificaResponsabile = 'PRATICHE.RESPONSABILE.UPDATE',
  EliminaResponsabile = 'PRATICHE.RESPONSABILE.DELETE',
  RicercaMetrica = 'PRATICHE.METRICA.QUERY',
  NuovoMetrica = 'PRATICHE.METRICA.ADD',
  ModificaMetrica = 'PRATICHE.METRICA.UPDATE',
  EliminaMetrica = 'PRATICHE.METRICA.DELETE',
  ModificaIrreperibilità = 'PRATICHE.IRREPERIBILTA.UPDATE',
  AssegnazionePratica = 'PRATICHE.ASSEGNAZIONE.UPDATE',
  GestioneNotifiche = 'PRATICHE.NOTIFICA.UPDATE',
}

export const PracticeResearchAuthorizations = [
  PracticeAuthorizations.RicercaPratiche,
  PracticeAuthorizations.ModificaIrreperibilità,
];

export const ResearchRegisterAuthorizations = [
  PracticeAuthorizations.RicercaRegistro,
  PracticeAuthorizations.NuovoRegistro,
  PracticeAuthorizations.ModificaRegistro,
  PracticeAuthorizations.EliminaRegistro,
];

export const TypePracticeAuthorizations = [
  PracticeAuthorizations.RicercaTipoPratica,
  PracticeAuthorizations.NuovoTipoPratica,
  PracticeAuthorizations.ModificaTipoPratica,
  PracticeAuthorizations.EliminaTipoPratica,
];

export const TypeOperationAuthorizations = [
  PracticeAuthorizations.RicercaTipoOperazione,
  PracticeAuthorizations.NuovoTipoOperazione,
  PracticeAuthorizations.ModificaTipoOperazione,
  PracticeAuthorizations.EliminaTipoOperazione,
];

export const ResponsibleAuthorizations = [
  PracticeAuthorizations.RicercaResponsabile,
  PracticeAuthorizations.NuovoResponsabile,
  PracticeAuthorizations.ModificaResponsabile,
  PracticeAuthorizations.EliminaResponsabile,
];

export const MetricAuthorizations = [
  PracticeAuthorizations.RicercaMetrica,
  PracticeAuthorizations.NuovoMetrica,
  PracticeAuthorizations.ModificaMetrica,
  PracticeAuthorizations.EliminaMetrica,
];

export const AssignOperatorPractice = [PracticeAuthorizations.AssegnazionePratica];

export const PracticeAuthorizationsList = [
  ...PracticeResearchAuthorizations,
  ...ResearchRegisterAuthorizations,
  ...TypePracticeAuthorizations,
  ...TypeOperationAuthorizations,
  ...ResponsibleAuthorizations,
  ...AssignOperatorPractice,
  PracticeAuthorizations.AperturaResidenza,
  PracticeAuthorizations.AperturaImmigrazione,
  PracticeAuthorizations.AperturaAnagrafeTemporanea,
  PracticeAuthorizations.AperturaIrreperibilita,
  PracticeAuthorizations.AperturaEmigrazione,
  PracticeAuthorizations.StampaIrreperibilita,
  PracticeAuthorizations.GestioneNotifiche,
];
